import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Link } from 'react-router-dom';

import { Container, Row, Col, CardBody, Alert } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { betSlipService } from '../../redux/betslip/services';
import { isUserAuthenticated } from '../../helpers/authUtils';
import LoaderWidget from '../../components/Loader/Loader';
import { CiMail } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import alertify from 'alertifyjs';

import logo from '../../assets/images/logo-dark.png';
import LoginModal from '../../components/LoginModal';
import { RxCross2 } from 'react-icons/rx';
import { useTranslation } from "react-i18next";

const ForgetPassword = ({ openLoginModal, setIsForgotModalOpen }) => {
    const [passwordResetSuccessful, setPasswordResetSuccessful] = useState(false);
    const [passwordResetfail, setPasswordResetfail] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [resMessage, setResMessage] = useState('');
    const [resErrorMessage, setResErroMessage] = useState(false);
    const [right, setRight] = useState(false);
    const [wrong, setWrong] = useState(false);
    const [showResults, setShowResults] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isRedirectToConfirm = useSelector(state => state.Auth.isRedirectToConfirm);
    const loading = useSelector(state => state.Auth.loading);
    const error = useSelector(state => state.Auth.error);

    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            // Cleanup if needed
        };
    }, []);

    const onDismiss = () => {
        setRight(false);
        setWrong(false);
        setPasswordResetSuccessful(false);
        setPasswordResetfail(false);
    };

    const handleValidSubmit = (event, values) => {
        setIsLoading(true);

        let formData = new FormData();
        formData.append('otp', values.otp);
        formData.append('password', values.password);

        betSlipService.resetPassword(formData).then((res) => {
            console.log('res', res);
            if (res.success === true && res.message === "Password is updated login again.") {
                navigate('/?login+Password%20is%20updated%20login%20again.');
                setIsForgotModalOpen(false);
                openLoginModal(true);
                setRight(true);
                setResErroMessage("")
                setResMessage(res.message);
              
            } else {
                setWrong(true);
                setResMessage("");
                setResErroMessage(res.message);
            }
        });
    };

    const sendOtp = (event, values) => {
        console.log('values', values.email);
        let formData = new FormData();
        formData.append('email', values.email);

        betSlipService.sendotp(formData).then((res) => {
            if (res.response_code === 200) {
                event.preventDefault();
                setShowResults(true);
                setRight(true);
                setResErroMessage("")
                setResMessage(res.message, " ");

            } else {
                setWrong(true);
                setResMessage("");
                setResErroMessage(res.message);
            }
        });
    };

    if (isUserAuthenticated()) {
        return <Navigate to='/' />;
    }

    return (
        <React.Fragment>
            {isRedirectToConfirm && (
                <div>
                    {/* Handle redirect to confirmation logic if needed */}
                </div>
            )}

            {/* <div className="account-pages">
                <section
                    // style={{
                    //     backgroundImage: "url(/images/account/casino-bg.jpg)",
                    //     backdropFilter: "blur(5px)",
                    //     boxShadow: 'inset 0 0 0 2000px rgb(32 32 32 / 55%)',
                    //     backgroundRepeat: 'no-repeat',
                    //     backgroundSize: 'cover'
                    // }}
                    className="account-section bg_img_login - mt-5 relative h-440 md:h-550 lg:h-680 xl:h-740 bg-no-repeat bg-center bg-cover flex items-center"
                >
                    <Container>
                        <Row className="justify-content-center">
                            <Col className="contain banner mb-50 justify-content-center align-items-center" lg={6}>
                                <div className="account__main">
                                    <div className="account__form__wrapper sign-up">
                                        <div className='second'>
                                           
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </div> */}


            {/* {isLoginModalOpen && (
                <div className="modal-overlay" onClick={() => setIsLoginModalOpen(false)}>
                    <div className="modal-box3" onClick={(e) => e.stopPropagation()}>
                    
                    <LoginModal
                        onLoginSuccess={() => {
                        
                        setIsLoginModalOpen(false); 
                        
                        }}
                    />
                    <p onClick={() => setIsLoginModalOpen(false)}>
                        <RxCross2 className="close-btn" />
                    </p>
                    </div>
                </div>
            )} */}

            <CardBody className="">
                <div className="forget-text">
                    <a href="/">
                        <i className="bi bi-lock"></i>
                        <div className="showName" style={{ display: showResults ? "none" : "block" }}>
                            <h3 className="mt-2 text--white">{t(`forgotPassword.forgotPassword`)}</h3>
                        </div>
                        <div className="showName" style={{ display: showResults ? "block" : "none" }}>
                            <h3 className="mt-2 text--white">{t(`resetPassword.title`)}</h3>
                        </div>
                    </a>
                </div>

                {loading && <LoaderWidget />}
                {error && <Alert color="danger" isOpen={!!error}>
                    <div dangerouslySetInnerHTML={{ __html: error }}></div>
                </Alert>}
                {/* {resMessage && 
                    <Alert color="success" isOpen={right}>
                        {resMessage}
                    </Alert>
                } */}

                {resMessage && (
                    <Alert color="success" isOpen={right}>
                        {resMessage}
                        {resMessage === "Password is updated login again." && (
                            <div
                                className=""
                                style={{ cursor: "pointer", fontWeight: 900 }}
                                onClick={openLoginModal}
                            >
                                Sign In
                            </div>
                        )}
                    </Alert>
                )}
                {resErrorMessage &&
                    <Alert color="danger" isOpen={wrong}>
                        {resErrorMessage}
                    </Alert>
                }

                <div className="showName" style={{ display: showResults ? "none" : "block" }}>
                    <AvForm className="account__form form row g-4" onValidSubmit={sendOtp}>
                        <div className="col-xl-12 col-md-12 mb-2">
                            <div className="form">
                                {/* <label htmlFor="email" className="form-label" style={{ color: '#000' }}>Email</label> */}
                                <div className="email-input-wrapper">
                                    <AvField
                                        id="email1"
                                        type="email"
                                        name="email"
                                        className="form--control form-control style--two"
                                        placeholder={t(`forgotPassword.placeholderE`)}
                                        validate={{
                                            required: { value: true, errorMessage: t(`forgotPassword.validation.enterEmail`) },
                                        }}
                                    />
                                    <CiMail className="email-input-icon" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <div className='center'>
                                    <button className="active-btn" type="submit">{t(`forgotPassword.sendOtp`)}</button>
                                </div>
                            </div>
                        </div>
                    </AvForm>
                </div>

                <AvForm className="account__form form row g-4" onValidSubmit={handleValidSubmit}>
                    <div className="showName" style={{ display: showResults ? "block" : "none" }}>
                        <div className="col-12">
                            <div className="form-group">
                                {/* <label htmlFor="otp" className="form-label" style={{ color: '#000' }}>OTP</label> */}
                                <AvField id="otp" name="otp" type="text" className="form--control form-control style--two" placeholder={t(`resetPassword.enterOtp`)} validate={{ required: { value: true, errorMessage: t('resetPassword.validation.enterOTP') } }} />
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="form-group">
                                {/* <label htmlFor="password" className="form-label" style={{ color: '#000' }}>Password</label> */}
                                <AvField id="pass" name="password" type="password" className="form--control form-control style--two" placeholder={t(`resetPassword.password`)} validate={{ required: { value: true, errorMessage: t('resetPassword.validation.enterPassword') } }} />
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="form-group">
                                {/* <label htmlFor="cnfm_password" className="form-label" style={{ color: '#000' }}>Confirm Password</label> */}
                                <AvField id="cnfm_password" name="cnfm_password" type="password" className="form--control form-control style--two" placeholder={t(`resetPassword.confirmPassword`)} validate={{ match: { value: 'password', errorMessage: t('resetPassword.validation.confirmPasswordMismatch') }, required: { value: true, errorMessage: t('resetPassword.validation.enterConfirmPassword') } }} />
                            </div>
                        </div>

                        <div className="col-12 mt-2">
                            <div className="form-group">
                                <div className='center'>
                                    <button className="active-btn" type="submit">{t(`resetPassword.changePassword`)}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </AvForm>

                <Row className="mt-1 mb-2">
                    <Col className="col-12 text-center text--white">
                        {/* <div className="backto-wrapper">
                            <div className="backto-text">Back to</div>
                            <div className="backto-link">
                                 <div
      className="text--white"
      style={{ cursor: "pointer", fontWeight: 900 }}
      onClick={() => setIsLoginModalOpen(true)}
    >
      Sign In
    </div>
                            </div>

                        </div> */}

                    </Col>
                </Row>
            </CardBody>
        </React.Fragment>
    );
};

export default ForgetPassword;
